import phpClient from '../phpAPI_Config'
import { tsWhoAmI } from '../../../Typescript/API_Response'
import { tsSampleRun } from '../../../Typescript/DB_Interface'
import { NewSampleRunPayload } from '../../Hooks/SampleRunHooks'

async function getSampleRunsForHolding(
  authState: tsWhoAmI,
  holding_id: number,
) {
  return await phpClient(authState)
    .get<any>(`/json/stuart/sample/getSampleRuns.php?HoldingID=${holding_id}`)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function getSampleRun(
  authState: tsWhoAmI,
  sample_run_id: number | string,
) {
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/sample/getSampleRun.php?SampleRunID=${sample_run_id}`,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function editSampleRun(authState: tsWhoAmI, payload: tsSampleRun) {
  return await phpClient(authState)
    .post<any>('/json/stuart/sample/editSampleRun.php', payload)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

async function newSampleRun(
  authState: tsWhoAmI,
  {
    holding_id,
    owner_id,
    run_type,
    destination,
    vessel_type,
    collection_id,
  }: NewSampleRunPayload,
) {
  const owner = owner_id ? '&OwnerID=' + owner_id : ''
  const collection = collection_id ? '&ScreenCollectionID=' + collection_id : ''
  return await phpClient(authState)
    .get<any>(
      `/json/stuart/sample/newSampleRun.php?HoldingID=${holding_id}&RunType=${run_type}&Destination=${destination}&VesselType=${vessel_type}` +
        owner +
        collection,
    )
    .then((response) => response.data)
    .catch((error) => Promise.reject(error.response))
}

const SampleRunService = {
  getSampleRunsForHolding,
  newSampleRun,
  getSampleRun,
  editSampleRun,
}

export default SampleRunService
